<template>
    <div class="d-flex d-md-none align-items-center w-100 justify-content-between pt-4">
        <div>{{ rows }} записей</div>
        <!-- Удалить example из data, после интеграции -->
        <v-select class="ftoggle" v-model="example.view" :options="['Список', 'Плитка']" :searchable="false"
            :deselectFromDropdown="false" :clearable="false">
        </v-select>
        <v-select class="ftoggle" v-model="example.paginate" :options="['10', '20', '30']" :searchable="false"
            :deselectFromDropdown="false" :clearable="false">
        </v-select>
    </div>
</template>
<script>
import example from '../data/example';
export default {
    name: "ListView",
    data: () => {
        return {example}
    }
}
</script>
